// extracted by mini-css-extract-plugin
module.exports = {"pageContentColor":"page-content-color-module--page-content-color--kn4WQ"};